import { useState } from "react";

const OPEN_HOUR = 9;
const CLOSE_HOUR = 21;

function isOpenNow() {
  const now = new Date();
  const day = now.getDay(); // 0 = Sunday, 6 = Saturday
  const hour = now.getHours();
  if (day === 0) return false; // Domingo cerrado
  if (hour < OPEN_HOUR || hour >= CLOSE_HOUR) return false;
  return true;
}

export default function WhatsAppFloat() {
  const phone = "34641712904";
  const msg = encodeURIComponent(
    "Hola Dentainhoa 👋\n\nMe gustaría más información sobre estos servicios:\n\n• Limpieza dental profunda\n• Blanqueamiento\n• Fluorización\n• Revisión general\n• Higiene y cuidado infantil\n• Cuidado geriátrico\n\n(Deja marcado el que te interese)"
  );
  const waUrl = `https://wa.me/${phone}?text=${msg}`;
  const [modal, setModal] = useState(false);

  const handleClick = (e) => {
    if (!isOpenNow()) {
      e.preventDefault();
      setModal(true);
    }
  };

  return (
    <>
      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        data-testid="whatsapp-float"
        aria-label="Escríbenos por WhatsApp"
        className="fixed bottom-6 right-6 z-[65] w-14 h-14 rounded-full bg-[#25D366] shadow-lg hover:shadow-xl hover:scale-105 transition-all grid place-items-center"
      >
        <svg viewBox="0 0 24 24" width="26" height="26" fill="white" aria-hidden="true">
          <path d="M20.52 3.48A11.94 11.94 0 0 0 12.02 0C5.4 0 .04 5.36.04 11.98c0 2.11.55 4.17 1.6 5.99L0 24l6.19-1.62a11.9 11.9 0 0 0 5.82 1.49h.01c6.62 0 11.98-5.36 11.98-11.99 0-3.2-1.24-6.2-3.48-8.4zM12.02 21.3h-.01a9.94 9.94 0 0 1-5.06-1.39l-.36-.21-3.67.96.98-3.58-.23-.37a9.96 9.96 0 0 1-1.52-5.33c0-5.5 4.48-9.98 9.98-9.98 2.67 0 5.17 1.04 7.05 2.93a9.9 9.9 0 0 1 2.92 7.06c0 5.5-4.48 9.98-9.98 9.98zm5.47-7.47c-.3-.15-1.77-.87-2.05-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.39-1.48-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.09 4.49.71.31 1.27.49 1.7.63.71.23 1.36.2 1.87.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35z"/>
        </svg>
      </a>

      {modal && (
        <div
          role="dialog"
          data-testid="whatsapp-offhours-modal"
          className="fixed inset-0 z-[80] grid place-items-center px-6"
          onClick={() => setModal(false)}
        >
          <div className="absolute inset-0 bg-[color:var(--bg-dark)]/40 backdrop-blur-sm" />
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-md rounded-2xl bg-[color:var(--bg-primary)] border border-[color:var(--border-subtle)] p-8 shadow-2xl"
          >
            <div className="text-xs uppercase tracking-[0.28em] text-[color:var(--text-secondary)] mb-3">Fuera de horario</div>
            <h3 className="font-heading text-3xl md:text-4xl tracking-tighter leading-tight mb-4">
              Gracias por tu <em className="italic text-[color:var(--accent)]">mensaje</em>.
            </h3>
            <p className="text-[color:var(--text-secondary)] leading-relaxed mb-6">
              Nuestro horario de atención es de <b className="text-[color:var(--text-primary)]">lunes a sábado de 9 a 21 h</b> 🕘. Te responderemos cuando volvamos a estar disponibles.
            </p>
            <div className="flex flex-col-reverse md:flex-row gap-3">
              <button
                onClick={() => setModal(false)}
                data-testid="whatsapp-modal-close"
                className="flex-1 rounded-full border border-[color:var(--border-strong)] px-5 py-2.5 text-sm hover:bg-[color:var(--bg-secondary)] transition-colors"
              >
                Cerrar
              </button>
              <a
                href={waUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setModal(false)}
                data-testid="whatsapp-modal-continue"
                className="flex-1 text-center rounded-full bg-[#25D366] text-white px-5 py-2.5 text-sm hover:brightness-95 transition-all"
              >
                Enviar de todos modos
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
